import { FC } from "react"
import { Card, CardItem, Container } from "./styles"

interface IConfirmActionsDropdownProps {
  onClose: () => void;
  onCreateAndOpen: () => void
  onCreateAndNew: () => void
  onCreateAndCopy: () => void
}

const ConfirmActionsDropdown: FC<IConfirmActionsDropdownProps> = ({
  onClose,
  onCreateAndOpen,
  onCreateAndNew,
  onCreateAndCopy,
}) => {
  const handleCreateAndOpen = () => {
    onCreateAndOpen();
    onClose();
  }

  const handleCreateAndNew = () => {
    onCreateAndNew();
    onClose();
  }

  const handleCreateAndCopy = () => {
    onCreateAndCopy();
    onClose();
  }

  return (
    <Container>
      <Card>
        <CardItem onClick={handleCreateAndOpen}>
          <span className="cardItemText">
            Criar e abrir
          </span>
        </CardItem>
        <CardItem onClick={handleCreateAndNew}>
          <span className="cardItemText">
            Criar e começar outra nova
          </span>
        </CardItem>
        <CardItem onClick={handleCreateAndCopy}>
          <span className="cardItemText">
            Criar e começar outra igual
          </span>
        </CardItem>
      </Card>
    </Container>
  )
}

export default ConfirmActionsDropdown
